import {
    GET_LICENSES,
    GET_FEATURES,
} from './action';

const initialState = {
    licenses: [],
    features: [],
};

export const reducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_LICENSES:
            return { ...state, licenses: action.payload };
        case GET_FEATURES:
            return { ...state, features: action.payload };
        default:
            return state;
    }
};